<template lang="jade">
	.election-component.election_calledseats(:election-embed="embed", :class="{ loading: loading }")

		GroupTitle(v-if="title", :title="title", :year="year", :fineprint="percentCounted")
		.election-component_content.election_calledseats_content

			.election_calledseats_party(
				v-if="calledSeats",
				v-for="party in parties",
				:key="party.party",
				:party="party.party",
				:style="{ 'background-size': party.backgroundSize }"
			)
				.election_calledseats_party_name {{ party.party }}
				.election_calledseats_party_count {{ party.count }}
			.election_calledseats_divider(:style="{ left: (majority / gridMax * 100) + '%' }")
			.election_calledseats_grid.election-fineprint.election-divider
				.election_calledseats_grid_item(v-for="n in gridSectors + 1")
					{{ Math.min((n-1) * gridScale, gridMax) }}

			.election_calledseats_caption.election-fineprint
				.election_calledseats_caption_disclaimer
					* As called by our experts.
				.election_calledseats_caption_majority 47 seats for majority

		LoadingOverlay(:loading="loading")
</template>
<script>
	import GroupTitle from './GroupTitle.vue';
	import LoadingOverlay from './LoadingOverlay.vue'

	export default {
		name: "called-seats",
		props: {
			embed: {
				type: Boolean
			},
			title: {
				type: String
			},
			maxSeats: {
				type: Number,
				required: true
			},
			realisticMax: {
				type: Number,
				required: true
			}
		},
		data: () => ({
			year: 2017,
			gridScale: 5
		}),
		computed: {
			calledSeats() {
				return this.$store.getters.calledseats();
			},
			gridSectors() {
				return Math.ceil(this.gridMax / this.gridScale);
			},
			parties() {

				return this.calledSeats ? this.calledSeats.parties.map( ({ party, count },) => ({
					party,
					count,
					backgroundSize: Math.min(count / this.realisticMax * 100, 100) + '% 100%'
				}) ) : null;
			},
			majority() {
				return Math.ceil(this.maxSeats / 2);
			},
			loading() { return this.$store.state.loading; },

			gridMax() {
				return this.realisticMax;

				const
					sorted = this.calledSeats ? this.calledSeats.parties.slice().sort( (a, b) => ( b.count - a.count ) ) : [],
					largestData = sorted && sorted[0] && sorted[0].count || 0;
				return Math.max(largestData, this.realisticMax);//keySeatData.slice().sort( (a, b) => ( b.count - a.count ))
			},
			percentCounted() {
				const percentRollCounted = this.$store.getters.percentCounted(this.year);
				return percentRollCounted ? `${percentRollCounted}% counted` : null;
			}
		},
		mounted() {
			console.log(this.calledSeats, typeof this.calledSeats)
			console.log('this.parties', this.parties)
		},
		components: { GroupTitle, LoadingOverlay }
	}
</script>
<style lang="scss">
	@import "src/_commons/assets/scss/global-sass";
	.election_calledseats {

		// padding: 0 $m-spacing;
		flex-basis: 100%;
		margin-bottom: $m-spacing;
		@include tgs-font-base-m;

		&_content {
			position: relative;
			//padding: 0 $m-spacing;
			//margin: $m-spacing 0;
			margin: $m-spacing;
		}


		&_party {
			display: flex;
			justify-content: space-between;
			padding: $m-spacing 0 $m-spacing $m-spacing;
			background-repeat: no-repeat;
			margin: 0 0 $m-spacing 0;
			background-size: 0% 100%;
			transition: all 0.5s 0.6s ease;
			border-left: $m-spacing solid;

			[tgs-font-custom-loaded=true] & {
				padding: #{$m-spacing * 1.5} 0 #{$m-spacing * 0.5} $m-spacing;
			}

			&[party="ALP"] {
				border-color: $color-ALP;
				background-image: linear-gradient(to right, $color-ALP-bar, $color-ALP-bar);
			}
			&[party="LNP"] {
				border-color: $color-LNP;
				background-image: linear-gradient(to right, $color-LNP-bar, $color-LNP-bar);
			}
			&[party="PHON"] {
				border-color: $color-PHON;
				background-image: linear-gradient(to right, $color-PHON-bar, $color-PHON-bar);
			}
			&[party="KAP"] {
				border-color: $color-KAP;
				background-image: linear-gradient(to right, $color-KAP-bar, $color-KAP-bar);
			}
			&[party="OTHER"] {
				border-color: $color-OTH;
				background-image: linear-gradient(to right, $color-OTH-bar, $color-OTH-bar);
			}
			&[party="UNDECIDED"] {
				border-color: #999;
				background-image: linear-gradient(to right, #e3e3e3, #e3e3e3);
			}
		}

		&_divider {
			position: absolute;
			top:0;
			width: 1px;
			height: 100%;
			left: 60%;
			background: rgba(0,0,0,0.2);
		}

		&_grid {
			display: flex;
			justify-content: space-between;

		}

		&_caption {
			display: flex;
			&_disclaimer {
				flex: 0 0 79%;
			}

			&_majority {
				flex: 1;
				padding-left: $m-spacing;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// CalledSeats.vue?51e7c6c8